/**
 * @generated SignedSource<<8936f3b0b6fc2c1ca26bf82aed0d63ce>>
 * @relayHash 6c662aebebdf7df04143c7154a662092
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5cdc1d161c16e0d49f65c49f538f45ff85a3082963e93bee9cc00a224726011

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type realtimeUpdater_issueUpdated_Subscription$variables = {
  cloudId: string;
  projectId: string;
};
export type realtimeUpdater_issueUpdated_Subscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProject: {
      readonly issueId: string;
      readonly key: string;
    } | null | undefined;
  } | null | undefined;
};
export type realtimeUpdater_issueUpdated_Subscription = {
  response: realtimeUpdater_issueUpdated_Subscription$data;
  variables: realtimeUpdater_issueUpdated_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "projectId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "issueId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "realtimeUpdater_issueUpdated_Subscription",
    "selections": [
      {
        "concreteType": "JiraSubscription",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "onIssueUpdatedByProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "realtimeUpdater_issueUpdated_Subscription",
    "selections": [
      {
        "concreteType": "JiraSubscription",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "onIssueUpdatedByProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e5cdc1d161c16e0d49f65c49f538f45ff85a3082963e93bee9cc00a224726011",
    "metadata": {},
    "name": "realtimeUpdater_issueUpdated_Subscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "eda2a4ad83757cada6fa3352cac3884a";

export default node;
